/**
 * @type {number}
 */
export const TABLE_HEIGHT_UP = 320

/**
 * @type {number}
 */
export const TABLE_HEIGHT_DOWN = 80

/**
 * @type {number}
 */
export const TABLE_HEIGHT_CELL = 55
